<template>
  <div>
    <div v-if="loading == false">
      <div v-if="results.length > 0">
        <p class="px-2 text-right text-sm">
          TOPLAM: <B>{{ total.deposit | toNum2 }}</B>
        </p>
      </div>
      <table
        class="uk-table metatrader-accounts-table uk-table-hover uk-table-divider"
      >
        <thead>
          <tr>
            <th>Açıklama</th>
            <th>Gerçekleşme Tarihi</th>
            <th class="text-right"><div class="text-right">Tutar</div></th>
          </tr>
        </thead>
        <tbody v-if="results">
          <tr :key="result.Deal" v-for="result in results">
            <td>
              {{ result.Comment }}
            </td>
            <td>{{ result.Time | formatDate }}</td>
            <td>
              <div class="text-right w-22">{{ result.Profit | toNum2 }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="center flex items-center justify-center" v-else>
      <vk-spinner></vk-spinner>
    </div>
  </div>
</template>

<script>
import http from "../../../../services/http";
export default {
  props: ["login", "type"],
  data() {
    return {
      results: [],
      total: {
        deposit: 0,
      },
      loading: true,
    };
  },
  methods: {
    getData() {
      if (this.login > 0) {
        http.mt5
          .getUserDeposit({ login: this.login, type: this.type })
          .then((e) => {
            this.results = e.data.result;
            this.total.deposit = this.results.reduce((sum, result) => {
              return sum + parseFloat(result.Profit);
            }, 0);

            this.loading = false;
          });
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style></style>
